import { useMemo } from 'react';
import {
  useExportHistoryListProbationReviewQuery,
  useExportProgressProbationReviewSubscription,
} from '@/common/graphql';
import type { ExportHistoryKind, UseExportHistoryResult } from './types';
import { toExportHistoryRow } from './types';

/** Query + Subscription + row-mapping for `kind: 'probationReview'`. Always called - internally no-ops via `skip` when inactive. */
export function useExportHistoryProbationReview(kind: ExportHistoryKind, onlyMyTask: boolean): UseExportHistoryResult {
  const skip = kind !== 'probationReview';

  const { data, loading, error, refetch } = useExportHistoryListProbationReviewQuery({
    skip,
    fetchPolicy: 'cache-and-network',
    variables: { onlyMyTask },
  });
  const history = useMemo(() => (data?.exportHistoryList ?? []).map(toExportHistoryRow), [data?.exportHistoryList]);

  const { data: progressData } = useExportProgressProbationReviewSubscription({ skip });
  const progress = useMemo(() => progressData?.exportProgress ?? [], [progressData?.exportProgress]);

  return { error, history, isActive: !skip, loading, progress, refetch };
}
